/**
 * Chat Service - API integration for chat functionality
 */

import api from '../api';

/**
 * Get list of user's chats
 */
export const getChats = async (offset = 0, limit = 20) => {
  const response = await api.get('/chat/', {
    params: { offset, limit }
  });
  return response.data;
};

/**
 * Get chat details with messages
 */
export const getChat = async (chatId) => {
  const response = await api.get(`/chat/${chatId}/`);
  return response.data;
};

/**
 * Get or create chat with a specific user
 */
export const getChatWithUser = async (userId) => {
  const response = await api.get(`/chat/with/${userId}/`);
  return response.data;
};

/**
 * Get messages in a chat
 */
export const getMessages = async (chatId, offset = 0, limit = 50) => {
  const response = await api.get(`/chat/${chatId}/messages/`, {
    params: { offset, limit }
  });
  return response.data;
};

/**
 * Send a message
 */
export const sendMessage = async (chatId, content) => {
  const response = await api.post(`/chat/${chatId}/messages/create/`, {
    content
  });
  return response.data;
};

/**
 * Mark messages as read
 */
export const markMessagesRead = async (chatId, messageIds = null) => {
  const response = await api.post(`/chat/${chatId}/messages/mark-read/`, {
    message_ids: messageIds
  });
  return response.data;
};